import React from "react";
import { Link } from "react-router-dom";
import { Home, Search, ArrowRight } from "lucide-react";

export default function NotFound() {
    return (
        <main className="min-h-screen bg-limestone-100 pt-32 pb-24 flex items-center justify-center" data-testid="notfound-page">
            <div className="asir-stripe absolute top-0 inset-x-0 h-[6px]" aria-hidden="true" />
            <div className="mx-auto max-w-2xl px-5 text-center">
                <p className="font-mono text-[13px] font-bold uppercase tracking-[0.22em] text-madder-500">
                    Error · 404
                </p>
                <h1
                    className="mt-5 font-display font-extrabold leading-[0.9] tracking-[-0.04em] text-ink-800 tabular-nums num-ltr"
                    style={{ fontSize: "clamp(120px, 18vw, 220px)" }}
                    data-testid="notfound-code"
                >
                    404
                </h1>
                <h2 className="mt-4 font-display text-[28px] sm:text-[36px] font-bold tracking-tight text-ink-800">
                    This address isn’t on our registry.
                </h2>
                <p className="mt-4 max-w-md mx-auto text-[17px] font-medium text-ink-600">
                    The page you followed either moved, expired, or was never registered at NourNet. Try searching for a domain instead.
                </p>

                <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
                    <Link
                        to="/preview"
                        data-testid="notfound-home"
                        className="inline-flex h-[56px] items-center gap-2 rounded-btn bg-madder-500 px-6 text-[16px] font-bold text-white shadow-madder hover:bg-madder-600"
                    >
                        <Home className="h-4 w-4" />
                        Go home
                    </Link>
                    <Link
                        to="/home-a#hero-search"
                        data-testid="notfound-search"
                        className="inline-flex h-[56px] items-center gap-2 rounded-btn border-2 border-ink-800 bg-white px-6 text-[16px] font-bold text-ink-800 hover:bg-ink-800 hover:text-white"
                    >
                        <Search className="h-4 w-4" />
                        Search a domain
                        <ArrowRight className="h-4 w-4 rtl-mirror" />
                    </Link>
                </div>
            </div>
        </main>
    );
}
